function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { cloneElement } from "react";
import { resolveIds } from "../../utils";
import { useStyle } from "./InputFieldset.style";
var InputFieldset = function(_param) {
    var hasActiveLabelTransition = _param.hasActiveLabelTransition, hasError = _param.hasError, height = _param.height, _hideLabel = _param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel, id = _param.id, isDisabled = _param.isDisabled, isRequired = _param.isRequired, isRtl = _param.isRtl, labelText = _param.labelText, size = _param.size, testID = _param.testID, top = _param.top, _variant = _param.variant, variant = _variant === void 0 ? 'default' : _variant, rest = _objectWithoutProperties(_param, [
        "hasActiveLabelTransition",
        "hasError",
        "height",
        "hideLabel",
        "id",
        "isDisabled",
        "isRequired",
        "isRtl",
        "labelText",
        "size",
        "testID",
        "top",
        "variant"
    ]);
    var ref = useStyle({
        hasActiveLabelTransition: hasActiveLabelTransition,
        hasError: hasError,
        hasLabel: !!id && !!labelText && !hideLabel,
        height: height,
        isDisabled: isDisabled,
        isRequired: isRequired,
        isRtl: isRtl,
        size: size,
        top: top,
        variant: variant
    }), fieldset = ref.fieldset, legend = ref.legend;
    var isElement = React.isValidElement(labelText);
    var legendDisplay = isElement ? cloneElement(labelText, _objectSpread({}, {
        isLegendContent: true
    })) : labelText;
    return _jsx("fieldset", _objectSpread({}, rest, {
        "aria-hidden": "true",
        css: fieldset
    }, resolveIds(id, testID, 'fieldset'), {
        children: _jsx("legend", _objectSpread({
            css: legend
        }, resolveIds(id, testID, 'legend'), {
            children: legendDisplay
        }))
    }));
};
export { InputFieldset };
export default InputFieldset;
